<template>
    <v-row class="fill-height" justify="center">
      <v-col cols="10" md="6">
        <v-row v-if="user" justify="center">
          <v-col>
            <h2>{{ title[locale] }} {{ user.display_name }}!</h2>
          </v-col>
        </v-row>
        <v-row v-if="admin || availableAssessments.D1 > 0" justify="start">
          <v-col>
            <v-btn
              color="primary"
              to="/assessment/D1"
              :large="isArabic"
              class="fixed-width-button"
              >{{ D1Text[locale] }}</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="admin || availableAssessments.D3 > 0" justify="start">
          <v-col>
            <v-btn
              color="primary"
              to="/assessment/D3"
              :large="isArabic"
              class="fixed-width-button"
              >{{ D3Text[locale] }}</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
</template>

<script>
// import { auth } from "@/common/firebase.js";
export default {
  name: "home",
  props: {
    user: Object
  },
  data() {
    return {
      title: {
        sv: "Välkommen",
        en: "Welcome",
        ar: "مرحبًا"
      },
      text: {
        sv: "",
        en: "",
        ar: ""
      },
      D1Text: {
        sv: "Bedöm ditt språk",
        en: "Assess your language",
        ar: "قم بتقييم لغتك"
      },
      D3Text: {
        sv: "Skapa språkprofil för tjänster",
        en: "Create job profile",
        ar: "Create job profile"
      },
      admin: false
    };
  },
  computed: {
    locale() {
      return this.$store.getters.GET_LOCALE.value;
    },
    isArabic() {
      return this.$store.getters.GET_LOCALE.value == "ar";
    },
    availableAssessments() {
      return this.$store.getters["user/GET_AVAILABLE_ASSESSMENT"];
    }
  },
  watch: {
    locale() {
      if(this.locale === "ar"){
        this.$vuetify.rtl = true;
      }else{
        this.$vuetify.rtl = false;
      }
    }
  },
  methods: {
    isAdmin() {
      return this.$store.getters["user/IS_ADMIN"];
    }
  },
  mounted() {
    this.admin = this.isAdmin();
  }
};
</script>

<style lang="scss" scoped>
.fixed-width-button {
  width: 100%;
  max-width: 350px;
  /*word-break: break-word;
  white-space: normal;
  text-align: center;*/
}
/*
.fixed-width-button .v-btn__content {
  flex: 1 !important;
}*/
</style>
